module.exports = __webpack_public_path__ + "static/media/copy_white.14ed32d2.svg";